<template>
  <div class="useritem">
    <a
      :href="`/user/${userInfo.uuid}`"
      target="_blank">
      <img
        :src="userInfo.avatar_url"
        class="avatar" />
    </a>
    <div
      class="info-box"
      style="visibility: visible">
      <a
        :href="`/user/${userInfo.uuid}`"
        target="_blank">
        <span class="username">
          <span
            class="name"
            style="max-width: 128px">
            {{ userInfo.uname }}
          </span>
        </span>
        <div
          class="position"
          :title="userInfo.job_title + ' @' + userInfo.ucompany">
          {{ userInfo.job_title }} @{{ userInfo.ucompany }}
        </div>
      </a>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ref, watch } from "vue";
import { ElMessage } from "element-plus";
import axiosInstance from "@/utils/axiosInstance";

const props = defineProps({
  userId: {
    type: String,
    required: true,
  },
});
//接口
interface UserInfo {
  uuid: string;
  uname: string;
  ucompany: string;
  job_title: string;
  avatar_url: string;
  blog_address: string;
  description: string;
  isvip: number;
  userlevel: number;
  phone_verified: number;
  wechat_verified: number;
  weibo_verified: number;
  github_verified: number;
  weibo_nickname: string;
  weibo_html_url: string;
  github_nickname: string;
  github_html_url: string;
  followers: number;
  following: number;
  created_at: string;
}

const userInfo = ref<UserInfo>({
  uuid: "",
  uname: "",
  ucompany: "",
  job_title: "",
  avatar_url: "",
  blog_address: "",
  description: "",
  isvip: "",
  userlevel: "",
  phone_verified: "",
  wechat_verified: "",
  weibo_verified: "",
  github_verified: "",
  weibo_nickname: "",
  weibo_html_url: "",
  github_nickname: "",
  github_html_url: "",
  followers: "",
  following: "",
  created_at: "",
});
//获取用户简介
const fetchUserInfo = async () => {
  try {
    await axiosInstance
      .get("/api/HomeUser/profile_id", {
        params: { uuid: props.userId },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          userInfo.value = result.data;
        }
      });
  } catch (error) {
    ElMessage.error("获取用户信息失败");
  }
};

// 监听userId变化
watch(
  () => props.userId,
  (newVal) => {
    if (newVal) {
      fetchUserInfo();
    }
  },
  { immediate: true }
);
</script>
<style scoped>
.useritem {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.useritem .avatar {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  -o-object-fit: cover;
  object-fit: cover;
  cursor: pointer;
}
.useritem .stats {
  display: flex;
}
.useritem .info-box {
  flex: 1 1 auto;
  min-width: 0;
  margin-left: 12px;
}
.username .name {
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 900;
}
.useritem .info-box .username {
  font-size: 16px;
  font-weight: 500;
  line-height: 2rem;
  color: #252933;
  white-space: pre-wrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.useritem .info-box .username,
.useritem .info-box .username .rank {
  display: flex;
  align-items: center;
}
.useritem .info-box .position {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #8a919f;
  font-weight: 400;
  line-height: 22px;
}
</style>
